module.exports = __webpack_public_path__ + "static/media/BTR-BUSD.6588082c.svg";